// @ts-nocheck
import { DateTime } from 'luxon'
import { formatPhoneNumberForDisplay } from '../utils/phoneNumberHelper'
import { Star, Phone, FileText } from 'lucide-react'

export default function CustomerCard({ customer, onClick, onCall }) {
  // 優先度バッジの色
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'vip':
        return 'bg-purple-100 text-purple-800 border-purple-300'
      case 'high':
        return 'bg-red-100 text-red-800 border-red-300'
      case 'normal':
        return 'bg-gray-100 text-gray-800 border-gray-300'
      case 'low':
        return 'bg-blue-100 text-blue-800 border-blue-300'
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300'
    }
  }

  // 優先度ラベル
  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'vip':
        return (
          <span className="flex items-center gap-1">
            <Star className="w-3 h-3" />
            VIP
          </span>
        )
      case 'high':
        return '優先'
      case 'normal':
        return '通常'
      case 'low':
        return '低'
      default:
        return '通常'
    }
  }

  // 最終通話日時のフォーマット
  const formatLastCall = (lastCallAt) => {
    if (!lastCallAt) return '通話履歴なし'
    
    try {
      const dt = DateTime.fromISO(lastCallAt)
      const now = DateTime.now()
      const diff = now.diff(dt, 'days').days

      if (diff < 1) {
        return dt.toRelative({ locale: 'ja' })
      } else if (diff < 30) {
        return dt.toFormat('M/d')
      } else {
        return dt.toFormat('yyyy/M/d')
      }
    } catch (err) {
      return lastCallAt
    }
  }

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer p-4 border border-gray-200"
    >
      {/* ヘッダー：名前と優先度 */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 truncate">
            {customer.name || '名前未設定'}
          </h3>
          {customer.companyName && (
            <p className="text-sm text-gray-600 truncate mt-1">
              {customer.companyName}
            </p>
          )}
        </div>
        
        {customer.priority && customer.priority !== 'normal' && (
          <span
            className={`ml-2 px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(
              customer.priority
            )}`}
          >
            {getPriorityLabel(customer.priority)}
          </span>
        )}
      </div>

      {/* 電話番号と発信ボタン */}
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm text-gray-700 flex items-center gap-1.5">
          <Phone className="w-4 h-4 text-gray-500" />
          {formatPhoneNumberForDisplay(customer.phoneNumber)}
        </p>
        
        {/* 発信ボタン */}
        {customer.phoneNumber && onCall && (
          <button
            onClick={(e) => {
              e.stopPropagation() // カードクリックイベントを防ぐ
              onCall(customer)
            }}
            className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
            title="発信"
          >
            <Phone className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* 通話統計 */}
      {customer.stats && (
        <div className="mb-3 text-sm text-gray-600">
          <span>通話: {customer.stats.totalCalls || 0}回</span>
          {customer.stats.lastCallAt && (
            <span className="ml-2">
              | 最終: {formatLastCall(customer.stats.lastCallAt)}
            </span>
          )}
        </div>
      )}

      {/* タグ */}
      {customer.tags && customer.tags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {customer.tags.slice(0, 3).map((tag, index) => (
            <span
              key={index}
              className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded-full"
            >
              {tag}
            </span>
          ))}
          {customer.tags.length > 3 && (
            <span className="px-2 py-1 text-xs text-gray-500">
              +{customer.tags.length - 3}
            </span>
          )}
        </div>
      )}

      {/* メモのプレビュー */}
      {customer.notes && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-xs text-gray-500 line-clamp-2 flex items-start gap-1.5">
            <FileText className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
            <span>{customer.notes}</span>
          </p>
        </div>
      )}
    </div>
  )
}
